import * as React from "react";
import {Fragment} from "react";

class Card extends React.Component {

	constructor(props) {
		super(props);
		this.null = this.null.bind(this);
	}

	null() {

	}

	render() {

		const {children, top, className, tags, onClick, handleAsButton, id, attributes} = this.props;

		const renderTags = (tags) => {
			let result = [];
			for (let i in tags) {
				result[i] = tags[i];
			}
			return result;
		}

		return (
			<Fragment>
				{!handleAsButton &&
					<div className={`card${className ? ` ${className}` : ''}`} {...attributes} onClick={onClick ? (p) => onClick(p) : () => this.null()} data-tags={tags ? renderTags(tags) : false} >
						{top &&
							<Fragment>
								{top}
							</Fragment>
						}
						{children &&
							<div className="card-body">
								{children}
							</div>
						}
					</div>
				}
				{handleAsButton &&
					<button data-id={id} type="button" className={`card${className ? ` ${className}` : ''}`} {...attributes} onClick={(p) => onClick(p)} data-tags={tags ? renderTags(tags) : false} >
						{top &&
							<Fragment>
								{top}
							</Fragment>
						}
						{children &&
							<div className="card-body">
								{children}
							</div>
						}
					</button>
				}
			</Fragment>
		);
	}
}

export default Card;
